export default "__VITE_ASSET__DI6SFcfu__"